
const BACKEND_LOCAL_OVERRIDE = null;
// const BACKEND_LOCAL_OVERRIDE = "https://passgo.com.ar";
// const BACKEND_LOCAL_OVERRIDE = "https://caar.ipsistemas.com.ar";

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const backendOrigin = isLocalhost
  ? BACKEND_LOCAL_OVERRIDE || 'http://localhost:7001'
  : '';

const socketOrigin = isLocalhost
  ? BACKEND_LOCAL_OVERRIDE || 'http://localhost:5000'
  : window.location.origin;

export const config = {
  URL_API: backendOrigin + '/api',
  URL_PUBLIC: backendOrigin + '/public',
  URL_SOCKET: socketOrigin,
};
